import { Shape } from 'components/widgets';

import type * as Types from './types';
import use from './hooks';

export default (({ children, className, favorite, title }) => {
  const { href } = use();

  return (
    <li className={className} data-favorite={favorite}>
      <Shape>
        <a href={href} title={title}>
          {children}
        </a>
      </Shape>
    </li>
  );
}) as Types.Default;
